export const WITHDRAWAL_STATUS = {
  PENDING: 'pending',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
};
